/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CongratsInputs */

const en_congrats = /** @type {(inputs: CongratsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Congratulations!`)
};

const ar_congrats = /** @type {(inputs: CongratsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تهانينا!`)
};

const de_congrats = /** @type {(inputs: CongratsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herzlichen Glückwunsch!`)
};

const es_congrats = /** @type {(inputs: CongratsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Felicidades!`)
};

const fr_congrats = /** @type {(inputs: CongratsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Félicitations !`)
};

const it_congrats = /** @type {(inputs: CongratsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Congratulazioni!`)
};

const ja_congrats = /** @type {(inputs: CongratsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`おめでとうございます！`)
};

const ko_congrats = /** @type {(inputs: CongratsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`축하합니다!`)
};

const pt_br_congrats = /** @type {(inputs: CongratsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parabéns!`)
};

const ru_congrats = /** @type {(inputs: CongratsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поздравляем!`)
};

const th_congrats = /** @type {(inputs: CongratsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขอแสดงความยินดีด้วย!`)
};

const tr_congrats = /** @type {(inputs: CongratsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tebrikler!`)
};

const zh_cn_congrats = /** @type {(inputs: CongratsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恭喜获得`)
};

const zh_tw_congrats = /** @type {(inputs: CongratsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恭喜獲得`)
};

/**
* | output |
* | --- |
* | "Congratulations!" |
*
* @param {CongratsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const congrats = /** @type {((inputs?: CongratsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CongratsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_congrats(inputs)
	if (locale === "ar") return ar_congrats(inputs)
	if (locale === "de") return de_congrats(inputs)
	if (locale === "es") return es_congrats(inputs)
	if (locale === "fr") return fr_congrats(inputs)
	if (locale === "it") return it_congrats(inputs)
	if (locale === "ja") return ja_congrats(inputs)
	if (locale === "ko") return ko_congrats(inputs)
	if (locale === "pt_br") return pt_br_congrats(inputs)
	if (locale === "ru") return ru_congrats(inputs)
	if (locale === "th") return th_congrats(inputs)
	if (locale === "tr") return tr_congrats(inputs)
	if (locale === "zh_cn") return zh_cn_congrats(inputs)
	return zh_tw_congrats(inputs)
});